export default "__VITE_ASSET__Cwm6viSH__"